const MIME_IMAGE = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']);
const EXT_IMAGE = /\.(jpe?g|png|gif|webp)$/i;

export function isSetupUploadableImage(file: File): boolean {
  if (MIME_IMAGE.has(file.type)) return true;
  if (!file.type && EXT_IMAGE.test(file.name)) return true;
  return false;
}
